import {SearchOptions} from "@/components/DrmPfInformationSearch/SearchOptions";
import {KeywordList} from "@/components/DrmPfInformationSearch/KeywordList";
import React from "react";
import {DrmPfInformationHooks} from "@/types/drmPfInformation";
import {useDrmPfInformationSearch} from "@/stores/drmPfInformationSearch";

export const SearchConditionContainer = ({drmPfInformationHooks}: { drmPfInformationHooks: DrmPfInformationHooks }) => {
  const {
    searchText, setSearchText,
    searchYear, setSearchYear,
  } = useDrmPfInformationSearch()

  function getYearOptions() {
    const yearList = [];
    const current = (new Date().getFullYear());
    const stop = 2;
    for (let i = current; i > current - stop; i--) {
      yearList.push(i);
    }
    return yearList;
  }

  return (
    <div className="drmPfInformation-search-condition uk-margin-top">
      <div className="uk-flex">
        <div className="uk-flex-1 uk-flex-column">
          <div className="uk-flex uk-flex-middle">
            <span className="uk-width-small">キーワード</span>
            <input
              className="input-search uk-width-1-2"
              onChange={event => setSearchText(event.target.value)}
              value={searchText}
            />
          </div>
          <div className="uk-flex uk-flex-middle uk-margin-small-top">
            <span className="uk-width-small">年度</span>
            <select
              className="input-search uk-width-1-2"
              onChange={event => setSearchYear(event.target.value)}
              value={searchYear}
            >
              <option value={""}>-- 選択してください --</option>
              {getYearOptions().map((value: number) => {
                return (<option value={value}>{value}</option>);
              })}
            </select>
          </div>
          <div className="uk-flex uk-flex-middle uk-margin-small-top">
            <span className="uk-width-small">情報区分</span>
            <div className="label-container">
              {drmPfInformationHooks.conditionList?.drmPfInformationTypes?.map(( type, index ) => (
                <label
                  key={index}
                >
                  <input
                    type="checkbox"
                    onChange={() => drmPfInformationHooks.onClickCheckType(type.id)}
                    checked={drmPfInformationHooks.checkTypeIds.includes(type.id)}
                  />
                  {type.name}
                </label>
              ))}
            </div>
          </div>
        </div>
        <div className="uk-flex uk-flex-bottom">
          <button className="button-search margin-left-32" onClick={drmPfInformationHooks.onClickSearch}>検索</button>
        </div>
      </div>
    </div>
  )
}